import React from 'react'

const Error = () => {
  return (
    <div className='notfound'>
      <h1>Oops Page can't be found</h1>
    </div>
  )
}

export default Error